export default "__VITE_ASSET__Caoopf5E__"